import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBaking: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconBaking"><Path d="M13 8C8.45934 11.0988 15.5407 12.9012 11 16" stroke="currentColor"/><Path d="M8.5 8C3.95934 11.0988 11.0407 12.9012 6.5 16" stroke="currentColor"/><Path d="M17.5 8C12.9593 11.0988 20.0407 12.9012 15.5 16" stroke="currentColor"/><Path d="M21.5 4.5H2.5V19.5H21.5V4.5Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconBaking;
